module.exports = __webpack_public_path__ + "img/SURVEY_DEPRESSIONSCALE_SM.93f310cf.png";